// FLOW Platform — thruWord: what colour each key wears.
//
// This lived inside game.js as six lines in applyKeyboardColors. It is its own
// module so the harness can run it directly, with a truth table, against the
// same file the bundle compiles — a rule nobody can test is a rule that drifts.
//
// The keyboard carries only the "somewhere / not in the word" memory. Greens are
// pinned onto the playboard in their right spots, so a green key would say twice
// what the board already says once.
//
// Jeff, 2026-09-23: "letters will stay in yellow when they also appear on the
// board in the proper place. this happens a lot." They did. `yellow` and `green`
// are separate sets gathered across every guess, so a letter guessed in the wrong
// place on one turn and the right place on the next landed in BOTH — and because
// greens are deliberately left off the keyboard, only the stale yellow showed.
//
// A yellow key means one thing: THERE IS ONE OF THESE YOU HAVE NOT PLACED YET. So
// it survives only while the answer holds more of that letter than the board is
// already showing in the right place. That keeps the honest case — LEVEL with one
// E pinned and one still loose, where yellow is true — and drops the lie.

/**
 * @param {Object}   o
 * @param {Iterable} o.yellow  letters seen in the wrong place, any turn
 * @param {Iterable} o.absent  letters that cannot appear in any live answer
 * @param {Object}   o.known   position -> letter already shown on the board
 *                             (hint-revealed letters and confirmed greens)
 * @param {string}   o.target  the answer the colours are drawn against
 * @returns {Object} lowercase letter -> 'yellow' | 'absent'
 */
export function keyColorMap(o) {
  o = o || {};
  const map = {};
  const lc = (v) => String(v == null ? '' : v).toLowerCase();

  // How many of each letter the board is already showing in its right place.
  const shown = {};
  const known = o.known || {};
  Object.keys(known).forEach((i) => {
    const L = lc(known[i]);
    if (L) shown[L] = (shown[L] || 0) + 1;
  });

  // How many of each letter the answer holds in total.
  const held = {};
  for (const ch of lc(o.target)) held[ch] = (held[ch] || 0) + 1;

  for (const raw of (o.yellow || [])) {
    const L = lc(raw);
    if ((held[L] || 0) > (shown[L] || 0)) map[L] = 'yellow';
  }
  for (const raw of (o.absent || [])) {
    const L = lc(raw);
    if (!map[L]) map[L] = 'absent';
  }
  return map;
}
